<script lang="ts" setup>
import { usePartnerBranding } from "~/composables/usePartnerBranding"

/**
 * Thin trust strip shown above the co-branded nav. It carries the "shopping
 * through <partner>" message and the "back to <partner>" action. The partner
 * logo intentionally lives only in the nav (ApplicationLogo) to avoid showing it
 * twice in the header. Text/border colors follow `--color-on-primary` so the bar
 * stays legible regardless of how light or dark the partner palette is.
 */
const { activePartner } = usePartnerBranding()
</script>

<template>
    <div
        v-if="activePartner"
        class="partner-topbar tw-w-full"
        data-cy="partner-top-bar"
    >
        <div
            class="max-container tw-flex tw-items-center tw-justify-between tw-gap-3 tw-py-2 tw-px-4"
        >
            <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
                <q-icon
                    name="fa-solid fa-lock"
                    size="13px"
                    class="tw-shrink-0 tw-opacity-70"
                />
                <span class="tw-text-sm tw-font-medium tw-truncate">
                    {{
                        $t("partner.shopping_through", {
                            name: activePartner.name,
                        })
                    }}
                </span>
            </div>

            <a
                :href="activePartner.returnUrl"
                class="partner-topbar__back tw-flex tw-items-center tw-gap-1.5 tw-shrink-0 tw-rounded-full tw-text-sm tw-font-semibold tw-px-3 tw-py-1 tw-transition-colors"
                data-cy="partner-back-button"
            >
                <q-icon name="fa-solid fa-arrow-left" size="13px" />
                <span class="tw-whitespace-nowrap">{{
                    $t("partner.back_to", { name: activePartner.name })
                }}</span>
            </a>
        </div>
    </div>
</template>

<style scoped>
.partner-topbar {
    background: var(--partner-topbar-bg, #004482);
    color: var(--partner-topbar-text, #fff);
    border-bottom: 1px solid
        color-mix(in srgb, var(--partner-topbar-text, #fff) 18%, transparent);
}

.partner-topbar__back {
    background: var(--partner-back-bg, #fff);
    color: var(--partner-back-text, #004482);
    box-shadow: 0 1px 2px rgb(0 0 0 / 0.15);
}

.partner-topbar__back:hover {
    opacity: 0.9;
}
</style>
